import type {
  ConversationNodeContactForm,
  ConversationNodeMessengerFormAsContactForm,
} from 'lib-shared-types-api';

type RoutedThroughContactFormProps = {
  node:
    | ConversationNodeContactForm
    | ConversationNodeMessengerFormAsContactForm;
};

export function RoutedThroughContactForm({
  node,
}: RoutedThroughContactFormProps): JSX.Element {
  return (
    <>
      Contact form <strong>{node.form_title ?? ''}</strong>
    </>
  );
}
